import { useMutation, useQueryClient } from "@tanstack/react-query";
import { isFunction } from "lodash";

import { deleteMeterUploadRow } from "@services/bulkMeterUpload";

export const useDeleteMeterUploadRow = ({
  onSuccess,
  ...options
}: Record<string, any> = {}) => {
  const queryClient = useQueryClient();
  return useMutation(
    ({ meterUploadId, rowId }: { meterUploadId: string; rowId: string }) =>
      deleteMeterUploadRow(meterUploadId, rowId),
    {
      ...options,
      onSuccess: (res, vars) => {
        queryClient.invalidateQueries({
          queryKey: ["meterUpload", vars.meterUploadId],
        });
        // Deleting a row can recompute the parent upload's status server-side (e.g.
        // removing the last failed row flips PartiallyCompleted → Completed), so the
        // uploads list must refetch too — otherwise it shows a stale status until a
        // hard refresh. Mirrors useFinalizeMeterUpload / useDeleteMeterUploadDraft.
        queryClient.invalidateQueries({ queryKey: ["meterUploads"] });
        if (isFunction(onSuccess)) onSuccess(res, vars);
      },
    },
  );
};
